// @flow
import React, { Component } from "react";
import moment from "moment";

import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";

import { GeneralModalForm } from "imagus-components";
import HistoryBillingLogs from "../../containers/billings/HistoryBillingLogs";
import UploadInvoiceFile from "../../../admin/containers/billings/UploadInvoiceFile";

type BillingItemPropsType = {
  history: { [key: string]: * },
  isAdmin?: boolean,
  companyId?: string,
  downloadFile: Function,
  uploadFile: Function,
  openSnackbar: Function
};

type BillingItemStatesType = {
  billModal: boolean,
  adminModal: boolean
};

class BillingItem extends Component<
  BillingItemPropsType,
  BillingItemStatesType
> {
  constructor(props: BillingItemPropsType) {
    super(props);
    this.state = {
      billModal: false,
      adminModal: false
    };
  }

  switchModalStatus = (modalName: string): * => (status: boolean): * => {
    this.setState({ [modalName]: status });
  };

  downloadLicence = async (historyId: string, historyUid: string): * => {
    this.props.downloadFile(historyId, historyUid);
  };

  render(): React$Element<*> {
    const history = this.props.history;
    let date = moment(history.month, "M").format("MMMM") + " " + history.year;
    let total = parseFloat(history.total).toFixed(2);
    return (
      <TableRow>
        <TableCell padding="dense">{date}</TableCell>
        <TableCell padding="dense">{"$" + total}</TableCell>
        <TableCell padding="dense">
          {history.paidOn ? (
            <span className="green-label">Paid</span>
          ) : (
            <span className="red-label">Due</span>
          )}
        </TableCell>
        <TableCell padding="dense">
          <Button
            color="primary"
            type="button"
            className="link-btn"
            onClick={(): * => this.switchModalStatus("billModal")(true)}
          >
            Check Bill
          </Button>
          <GeneralModalForm
            title={"View Full Bill for " + date}
            open={this.state.billModal}
            handleModalStatus={this.switchModalStatus("billModal")}
            maxMd
            form={
              <HistoryBillingLogs
                onClose={(): * => this.switchModalStatus("billModal")(false)}
                date={date}
                total={total}
                billingId={history.id}
                isAdmin={this.props.isAdmin}
                companyId={this.props.companyId}
              />
            }
          />
        </TableCell>
        <TableCell padding="dense">
          {history.invoice && (
            <Button
              color="primary"
              type="button"
              className="link-btn"
              onClick={(): * => this.downloadLicence(history.id, history.uuid)}
            >
              Invoice
            </Button>
          )}
        </TableCell>
        {this.props.isAdmin && (
          <TableCell padding="dense">
            <Button
              color="primary"
              type="button"
              className="link-btn"
              onClick={(): * => this.switchModalStatus("adminModal")(true)}
            >
              Admin
            </Button>
            <GeneralModalForm
              title="Upload Invoice"
              open={this.state.adminModal}
              handleModalStatus={this.switchModalStatus("adminModal")}
              form={
                <UploadInvoiceFile
                  onClose={(): * => this.switchModalStatus("adminModal")(false)}
                  billingId={history.id}
                  billingUid={history.uuid}
                  companyId={this.props.companyId}
                  invoice={history.invoice}
                  paidOn={history.paidOn}
                  uploadFile={this.props.uploadFile}
                  openSnackbar={this.props.openSnackbar}
                />
              }
            />
          </TableCell>
        )}
      </TableRow>
    );
  }
}

type HistoryBillingsPropsType = {
  histories: Array<{ [key: string]: * }>,
  isAdmin?: boolean,
  companyId?: string,
  downloadFile: Function,
  uploadFile: Function,
  openSnackbar: Function
};

type HistoryBillingsStatesType = {
  displayAll: boolean
};

class HistoryBillings extends Component<
  HistoryBillingsPropsType,
  HistoryBillingsStatesType
> {
  Lines: number = 2;
  constructor(props: HistoryBillingsPropsType) {
    super(props);
    this.state = {
      displayAll: false
    };
  }

  toggleDisplayAll = (): * => {
    this.setState({ displayAll: true });
  };

  render(): React$Element<*> {
    const RowCount = this.props.isAdmin ? 6 : 5;

    return (
      <Paper className="box-wrapper">
        <Typography variant="h5" className="form-text">
          Bill History
        </Typography>
        <Table className="app-table center">
          <TableHead>
            <TableRow>
              <TableCell className="blue-shine" padding="dense">
                Date
              </TableCell>
              <TableCell className="blue-shine" padding="dense">
                Total Fee(AUD)
              </TableCell>
              <TableCell className="blue-shine" padding="dense">
                Status
              </TableCell>
              <TableCell className="blue-shine" padding="dense">
                Bill
              </TableCell>
              <TableCell className="blue-shine" padding="dense">
                Invoice
              </TableCell>
              {this.props.isAdmin && (
                <TableCell className="blue-shine" padding="dense">
                  Action
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.histories.map(
              (history: *, i: number): * => {
                if (i <= this.Lines || this.state.displayAll) {
                  return (
                    <BillingItem
                      history={history}
                      isAdmin={this.props.isAdmin}
                      companyId={this.props.companyId}
                      downloadFile={this.props.downloadFile}
                      uploadFile={this.props.uploadFile}
                      openSnackbar={this.props.openSnackbar}
                      key={i}
                    />
                  );
                } else {
                  return null;
                }
              }
            )}
            {!this.state.displayAll &&
            this.props.histories.length > parseInt(this.Lines) + 1 ? (
                <TableRow>
                  <TableCell padding="dense" colSpan={RowCount}>
                    <span
                      onClick={this.toggleDisplayAll}
                      className="form-link-green"
                    >
                      View All
                    </span>
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell padding="dense" colSpan={RowCount}>
                    <span className="light">No More Bills</span>
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

export default HistoryBillings;
